import { useState } from "react";
import { useModuleBEM, IconNameEnum } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import { CarsSearchBar } from "./CarsSearchBar";
import styles from "./CombinedSearchBar.module.scss";
import { HotelSearchBar } from "./HotelSearchBar";
import { useShowCarsSearch } from "@/hooks/useShowCarsSearch";

enum SearchType {
  Hotels = "Hotels",
  Cars = "Cars",
}

export const CombinedSearchBar = () => {
  const { t } = useI18nContext();
  const [className, cn] = useModuleBEM(styles, "CombinedSearchBar");
  const [searchType, setSearchType] = useState<SearchType>(SearchType.Hotels);

  const showCarsSearch = useShowCarsSearch();

  const renderSearch = () => {
    if (searchType === SearchType.Hotels || !showCarsSearch) {
      return <HotelSearchBar />;
    }
    return <CarsSearchBar />;
  };

  return (
    <div className={className}>
      {showCarsSearch ? (
        <div className={cn("search-type-toggle")}>
          <button
            className={cn("toggle-button", {
              active: searchType === SearchType.Hotels,
            })}
            onClick={() => setSearchType(SearchType.Hotels)}
          >
            <Icon iconName={IconNameEnum.bed} />
            {t("home.searchBar.hotels")}
          </button>
          <button
            className={cn("toggle-button", {
              active: searchType === SearchType.Cars,
            })}
            onClick={() => setSearchType(SearchType.Cars)}
          >
            <Icon iconName={IconNameEnum.car} useCurrentColor={false} />
            {t("home.searchBar.cars")}
          </button>
        </div>
      ) : null}
      <div className={cn("content")}>{renderSearch()}</div>
    </div>
  );
};
